export default {"src":"/_next/static/media/secure.7d406529.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};